/* eslint-disable global-require */
import angular from 'angular';

import UploadFileController from './upload-file.controller';

export default angular.module('autoboard.formUploadFile', [])
  .directive('formUploadFile', () => {
    'ngInject';

    return {
      controller: UploadFileController,
      restrict: 'E',
      scope: {
        exit: '&',
        show: '=',
        section: '@',
        identifier: '@',
      },
      templateUrl: require('./upload-file.template.html'),
    };
  })
  .name;
